var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeurerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.1 67.2",
    style: {
      enableBackground: "new 0 0 255.1 67.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.3,50.5c-3.4,4.4-9,6.5-14.4,5.4c-5.3-1.4-9.3-5.9-10.2-11.3c-0.9-5.5,1.6-11,6.3-14 c4.6-2.7,10.3-2.6,14.7,0.3c2.1,1.4,3.7,3.4,4.8,5.7C39.6,41.1,39.1,46.4,36.3,50.5 M44.1,58.6c5.3-6,7-15,4.8-23.2 C46.1,26.3,38,18.8,28.5,17.8c-6.4-0.6-12.5,0.7-17.1,4.5V0H0v40.7c0,5.3,0.8,9.4,3,13.4c4.6,8.7,13.8,13.6,24,13.1 C33.6,66.6,39.7,63.5,44.1,58.6 M91.6,38.6H64.8c1.4-6.5,6.6-10.7,13.5-10.7C85.5,27.9,90.4,31.8,91.6,38.6 M102.2,47.5 c0.3-1.8,0.4-3.5,0.5-5.3c0-14.3-10-24.7-24.4-24.7S53.5,27.9,53.5,42.4s10.8,24.8,25.7,24.8c8.3,0,15.4-2.8,20.2-7.4l-6.3-7.8 c-3.9,3.2-8.9,4.8-13.9,4.7c-7,0-12.1-3.5-14-9.2L102.2,47.5z M150.7,46.3v-27H139v26.5c0,6.5-3.9,10.1-10.2,10.1 s-10.2-3.6-10.2-10.1V19.3h-11.7v27.1c0,12.7,9.5,20.8,21.9,20.8S150.7,59,150.7,46.3 M178.4,29.3V18c-12.4,0-21.9,8.1-21.9,20.8 v27.1h11.7V39.4C168.2,32.9,172.1,29.3,178.4,29.3 M217.9,38.6H191c1.4-6.5,6.6-10.7,13.5-10.7C211.7,27.9,216.6,31.8,217.9,38.6  M228.4,47.5c0.3-1.8,0.4-3.5,0.5-5.3c0-14.3-10-24.7-24.4-24.7s-24.8,10.3-24.8,24.9s10.8,24.8,25.7,24.8 c8.3,0,15.4-2.8,20.2-7.4l-6.3-7.8c-3.9,3.2-8.9,4.8-13.9,4.7c-7,0-12.1-3.5-14-9.2L228.4,47.5z M255.1,29.3V18 c-12.4,0-21.9,8.1-21.9,20.8v27.1h11.7V39.4C244.9,32.9,248.8,29.3,255.1,29.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeurerLogo);
export default __webpack_public_path__ + "static/media/beurer-logo.78b43216968b8d30933f4ff91b3eacc7.svg";
export { ForwardRef as ReactComponent };